import { render, staticRenderFns } from "./DialogSend.vue?vue&type=template&id=063f7f74"
import script from "./DialogSend.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSend.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports